import { createApp } from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import './assets/main.css'
import api from '@/plugins/axios';
import { applyThemeColor } from './composables/useThemeColor';
import { THEME_COLOR } from './config/theme';

applyThemeColor(THEME_COLOR);

const app = createApp(App);

app.config.globalProperties.$api = api;

app.use(store);
app.use(router);

// Global error handler
app.config.errorHandler = (err, vm, info) => {
  console.error('[Global Error]', err);
  console.error('Info:', info);
};

store.dispatch('auth/initializeAuth').finally(() => {
  app.mount('#app');
});
